import { render, staticRenderFns } from "./LeaderboardGeneratingLoader.vue?vue&type=template&id=09455f62"
import script from "./LeaderboardGeneratingLoader.vue?vue&type=script&lang=js"
export * from "./LeaderboardGeneratingLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports